import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const EkiTrigger = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const ekiTrigger = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'ekiTrigger'));

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const handleEki = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Forward Accumulator',
      'EKI trigger changed',
      isDefined(value) ? value.toString() : 'cleared',
    );

    return check({
      ekiTrigger: isDefined(value) ? value : null,
    });
  };

  return (
    <FormField formattedMessageId="forwardAccumulator.form.ekiTrigger">
      <TradeCaptureValidationWrapper validation={validation?.ekiTrigger}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={ekiTrigger}
          maxDecimals={9}
          onChange={handleEki}
          size="sm"
          data-e2e="eki-trigger"
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default EkiTrigger;
